export default __webpack_public_path__ + "static/ddebit2-418ff1a1f82653ebb7c417bcff87c9b6.png";